/** @file Hashes bytes with the bundle's algorithm: fnv1a64 by default, or the injected hash (sha256). */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { fnv1a64 } from '@zilo/pose3d-export/hash/fnv1a64';
import type { HashAlgo } from '@zilo/pose3d-export/types/bundle';
import type { ExportDeps } from '@zilo/pose3d-export/types/exportDeps';

/** `{ algo, hash }` of `bytes`; `hashAlgo` other than `fnv1a64` needs `deps.hash` (`VALIDATION` otherwise). */
export function hashBytes(bytes: Uint8Array, deps: Pick<ExportDeps, 'hash' | 'hashAlgo'>): { algo: HashAlgo; hash: string } {
  const algo = deps.hashAlgo ?? 'fnv1a64';
  if (deps.hash !== undefined) return { algo, hash: deps.hash(bytes) };
  if (algo !== 'fnv1a64') return throwError(ERROR_CODES.VALIDATION, { hashAlgo: algo }, { hint: `pass deps.hash for ${algo}` });
  return { algo, hash: fnv1a64(bytes) };
}
